/* tslint:disable */
/* eslint-disable */
/**
 * B2B Card
 * APIs for using and interacting with credit cards  # Tracking Metrics * `b2bportal.booking.payment.error`   * tags: `api_version`, `error_code`, `payment`, `tenantid` * `b2bportal.card.delete.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.delete.success`   * tags: `api_version`, `tenantid` * `b2bportal.card.get.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.get.success`   * tags: `api_version`, `tenantid` * `b2bportal.card.list.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.list.success`   * tags: `api_version`, `tenantid` * `b2bportal.card.verify.failure`   * tags: `api_version`, `error_code`, `tenantid` * `b2bportal.card.verify.success`   * tags: `api_version`, `tenantid` * `b2bportal.quote.payment.error`   * tags: `api_version`, `error_code`, `payment`, `quote_action`, `tenantid`   # Tracking Error Codes * `authorize_failure` * `bad_request` * `capture_failure` * `card_declined` * `create_payment_failed` * `excessive_user_activity` * `expired_card` * `generic_error` * `inactive_card` * `internal_error` * `invalid_address` * `invalid_currency` * `invalid_cvv` * `limit_exceeded` * `negative_payment_amount` * `not_enough_balance` * `payment_not_found` * `refund_failure` * `request_deserialization_error` * `response_serialization_error` * `service_error` * `unknown_card` * `unknown`  
 *
 * The version of the OpenAPI document: v0p33
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface Alias {
    'value': string;
}
/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
/**
 * @type AnyResponse
 * @export
 */
export type AnyResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & AnySuccess;

export interface AnySuccess {
    'value': any;
    'Response': ResponseEnum;
}


export interface AsIs {
    'ScanResult': ScanResultEnum;
}


export interface CardDeclined {
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


/**
 * @type CardError
 * @export
 */
export type CardError = { CardError: 'AuthorizeFailure' } & CardErrorAuthorizeFailure | { CardError: 'CaptureFailure' } & CardErrorCaptureFailure | { CardError: 'CardDeclined' } & CardErrorCardDeclined | { CardError: 'CardErrorCode' } & CardErrorCardErrorCode | { CardError: 'CreatePaymentFailed' } & CardErrorCreatePaymentFailed | { CardError: 'ExpiredCard' } & CardErrorExpiredCard | { CardError: 'InactiveCard' } & CardErrorInactiveCard | { CardError: 'InvalidCurrency' } & CardErrorInvalidCurrency | { CardError: 'LimitExceeded' } & CardErrorLimitExceeded | { CardError: 'NegativePaymentAmount' } & CardErrorNegativePaymentAmount | { CardError: 'NotEnoughBalance' } & CardErrorNotEnoughBalance | { CardError: 'PaymentNotFound' } & CardErrorPaymentNotFound | { CardError: 'RefundFailure' } & CardErrorRefundFailure;

export interface CardErrorAuthorizeFailure {
    'CardError': CardErrorEnum;
}


export interface CardErrorCaptureFailure {
    'CardError': CardErrorEnum;
}


export interface CardErrorCardDeclined {
    'CardError': CardErrorEnum;
}


export interface CardErrorCardErrorCode {
    'code': string;
    'message'?: string;
    'CardError': CardErrorEnum;
}


export interface CardErrorCreatePaymentFailed {
    'CardError': CardErrorEnum;
}


export const CardErrorEnum = {
    AuthorizeFailure: 'AuthorizeFailure',
    CaptureFailure: 'CaptureFailure',
    CardDeclined: 'CardDeclined',
    CardErrorCode: 'CardErrorCode',
    CreatePaymentFailed: 'CreatePaymentFailed',
    ExpiredCard: 'ExpiredCard',
    InactiveCard: 'InactiveCard',
    InvalidCurrency: 'InvalidCurrency',
    LimitExceeded: 'LimitExceeded',
    NegativePaymentAmount: 'NegativePaymentAmount',
    NotEnoughBalance: 'NotEnoughBalance',
    PaymentNotFound: 'PaymentNotFound',
    RefundFailure: 'RefundFailure'
} as const;

export type CardErrorEnum = typeof CardErrorEnum[keyof typeof CardErrorEnum];


/**
 * Card is expired. User should try another payment method
 * @export
 * @interface CardErrorExpiredCard
 */
export interface CardErrorExpiredCard {
    'CardError': CardErrorEnum;
}


/**
 * Card is blocked. User should unblock card and try again
 * @export
 * @interface CardErrorInactiveCard
 */
export interface CardErrorInactiveCard {
    'CardError': CardErrorEnum;
}


export interface CardErrorInvalidCurrency {
    'CardError': CardErrorEnum;
}


/**
 * Withdrawal amount exceeded the allowed limit. User should try a different method or a lower amount
 * @export
 * @interface CardErrorLimitExceeded
 */
export interface CardErrorLimitExceeded {
    'CardError': CardErrorEnum;
}


export interface CardErrorNegativePaymentAmount {
    'CardError': CardErrorEnum;
}


/**
 * Not enough balance. User should use a different payment method
 * @export
 * @interface CardErrorNotEnoughBalance
 */
export interface CardErrorNotEnoughBalance {
    'CardError': CardErrorEnum;
}


export interface CardErrorPaymentNotFound {
    'CardError': CardErrorEnum;
}


export interface CardErrorRefundFailure {
    'CardError': CardErrorEnum;
}


export interface CardPayment {
    'paymentAmount': Amount;
    'paymentId': string;
}
export const CardType = {
    american_express: 'american_express',
    dankort: 'dankort',
    diners_club: 'diners_club',
    discover: 'discover',
    jcb: 'jcb',
    maestro: 'maestro',
    master: 'master',
    visa: 'visa'
} as const;

export type CardType = typeof CardType[keyof typeof CardType];


export interface CompleteInteractiveAuthFailure {
    'errors': Array<InteractiveAuthError>;
    'CompleteInteractiveAuthResponse': CompleteInteractiveAuthResponseEnum;
}


export interface CompleteInteractiveAuthRequest {
    'token': string;
    'results': Array<PaymentAuthActionOpaqueValue>;
}
/**
 * @type CompleteInteractiveAuthResponse
 * @export
 */
export type CompleteInteractiveAuthResponse = { CompleteInteractiveAuthResponse: 'CompleteInteractiveAuthFailure' } & CompleteInteractiveAuthFailure | { CompleteInteractiveAuthResponse: 'CompleteInteractiveAuthSuccess' } & CompleteInteractiveAuthSuccess;

export const CompleteInteractiveAuthResponseEnum = {
    CompleteInteractiveAuthFailure: 'CompleteInteractiveAuthFailure',
    CompleteInteractiveAuthSuccess: 'CompleteInteractiveAuthSuccess'
} as const;

export type CompleteInteractiveAuthResponseEnum = typeof CompleteInteractiveAuthResponseEnum[keyof typeof CompleteInteractiveAuthResponseEnum];


/**
 * @type CompleteInteractiveAuthResponseResponse
 * @export
 */
export type CompleteInteractiveAuthResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & CompleteInteractiveAuthResponseSuccess;

export interface CompleteInteractiveAuthResponseSuccess {
    'value': CompleteInteractiveAuthResponse;
    'Response': ResponseEnum;
}


export interface CompleteInteractiveAuthSuccess {
    'CompleteInteractiveAuthResponse': CompleteInteractiveAuthResponseEnum;
}


export interface CreditCard {
    'updatedAt'?: string;
    'zip': string;
    'year': number;
    'numberDisplay': string;
    'country': string;
    'alias'?: Alias;
    'lastName': string;
    'firstName': string;
    'id': string;
    'last4'?: string;
    'token': string;
    'createdAt': string;
    'bin'?: string;
    'cardType': CardType;
    'scanned': ScanResult;
    'month': number;
}


/**
 * @type CreditCardListResponse
 * @export
 */
export type CreditCardListResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & CreditCardListSuccess;

export interface CreditCardListSuccess {
    'value': Array<CreditCard>;
    'Response': ResponseEnum;
}


export interface DeletePaymentMethodRequest {
    'paymentId': string;
}
export interface ErrorCode {
    'code': string;
    'details'?: string;
}
export interface ExcessiveUserActivity {
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


export interface Failure {
    'errors': Array<ErrorCode>;
    'Response': ResponseEnum;
}


export interface GenericError {
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


export interface GetPaymentMethodRequest {
    'paymentId': string;
}
export const InteractiveAuthError = {
    internal_error: 'internal_error',
    payment_session_expired: 'payment_session_expired'
} as const;

export type InteractiveAuthError = typeof InteractiveAuthError[keyof typeof InteractiveAuthError];


/**
 * The BFF encountered an internal error while retrieving interactive authentication information. As a result, the purchase flow should be abandoned.
 * @export
 * @interface InteractiveAuthFailure
 */
export interface InteractiveAuthFailure {
    'errors': Array<InteractiveAuthError>;
    'InteractiveAuthResponse': InteractiveAuthResponseEnum;
}


/**
 * Interactive authentication is not required for this payment method. The frontend can proceed with the normal fulfillment flow and poll for the fulfillment state.
 * @export
 * @interface InteractiveAuthNotRequested
 */
export interface InteractiveAuthNotRequested {
    'InteractiveAuthResponse': InteractiveAuthResponseEnum;
}


/**
 * Interactive authentication information is not yet ready. The frontend should continue to query the pollInteractiveAuth endpoint.
 * @export
 * @interface InteractiveAuthPending
 */
export interface InteractiveAuthPending {
    'InteractiveAuthResponse': InteractiveAuthResponseEnum;
}


/**
 * Interactive authentication information is available and should be used by the frontend. The frontend should complete the authentication process and then submit the authentication result to /completeInteractiveAuth.
 * @export
 * @interface InteractiveAuthPendingInteractivePaymentAuth
 */
export interface InteractiveAuthPendingInteractivePaymentAuth {
    'token': string;
    'actions': Array<PaymentAuthActionOpaqueValue>;
    'InteractiveAuthResponse': InteractiveAuthResponseEnum;
}


/**
 * @type InteractiveAuthResponse
 * Response from the pollInteractiveAuth endpoint.
 * @export
 */
export type InteractiveAuthResponse = { InteractiveAuthResponse: 'Failure' } & InteractiveAuthFailure | { InteractiveAuthResponse: 'NotRequested' } & InteractiveAuthNotRequested | { InteractiveAuthResponse: 'Pending' } & InteractiveAuthPending | { InteractiveAuthResponse: 'PendingInteractivePaymentAuth' } & InteractiveAuthPendingInteractivePaymentAuth;

export const InteractiveAuthResponseEnum = {
    Failure: 'Failure',
    NotRequested: 'NotRequested',
    Pending: 'Pending',
    PendingInteractivePaymentAuth: 'PendingInteractivePaymentAuth'
} as const;

export type InteractiveAuthResponseEnum = typeof InteractiveAuthResponseEnum[keyof typeof InteractiveAuthResponseEnum];


/**
 * @type InteractiveAuthResponseResponse
 * @export
 */
export type InteractiveAuthResponseResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & InteractiveAuthResponseSuccess;

export interface InteractiveAuthResponseSuccess {
    'value': InteractiveAuthResponse;
    'Response': ResponseEnum;
}


export interface InvalidAddress {
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


export interface InvalidCVV {
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


/**
 * `amount` - The amount to be charged in the currency to be charged.
 * @export
 * @interface ListPaymentMethodsRequest
 */
export interface ListPaymentMethodsRequest {
    'amount'?: Amount;
}
/**
 * @type MaybeCreditCardResponse
 * @export
 */
export type MaybeCreditCardResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & MaybeCreditCardSuccess;

export interface MaybeCreditCardSuccess {
    'value'?: CreditCard;
    'Response': ResponseEnum;
}


export interface NotAvailable {
    'ScanResult': ScanResultEnum;
}


export interface NotScanned {
    'ScanResult': ScanResultEnum;
}


/**
 * PaymentAuthAction is the supported authentication actions.

* `InteractivePayment3DSAdyenAuthAction` - 3DS auth action offered by Adyen
* `InteractivePayment3DSAdyenAuthResult` - 3DS auth result to Adyen
 * @export
 * @enum {string}
 */

export const PaymentAuthAction = {
    InteractivePayment3DSAdyenAuthAction: 'InteractivePayment3DSAdyenAuthAction',
    InteractivePayment3DSAdyenAuthResult: 'InteractivePayment3DSAdyenAuthResult'
} as const;

export type PaymentAuthAction = typeof PaymentAuthAction[keyof typeof PaymentAuthAction];


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface PaymentAuthActionOpaqueValue
 */
export interface PaymentAuthActionOpaqueValue {
    'type': PaymentAuthAction;
    'value': any;
}


/**
 * @type PaymentVerifyResult
 * @export
 */
export type PaymentVerifyResult = { PaymentVerifyResult: 'CardDeclined' } & CardDeclined | { PaymentVerifyResult: 'ExcessiveUserActivity' } & ExcessiveUserActivity | { PaymentVerifyResult: 'GenericError' } & GenericError | { PaymentVerifyResult: 'InvalidAddress' } & InvalidAddress | { PaymentVerifyResult: 'InvalidCVV' } & InvalidCVV | { PaymentVerifyResult: 'Success' } & Success | { PaymentVerifyResult: 'UnknownCard' } & UnknownCard;

export const PaymentVerifyResultEnum = {
    CardDeclined: 'CardDeclined',
    ExcessiveUserActivity: 'ExcessiveUserActivity',
    GenericError: 'GenericError',
    InvalidAddress: 'InvalidAddress',
    InvalidCVV: 'InvalidCVV',
    Success: 'Success',
    UnknownCard: 'UnknownCard'
} as const;

export type PaymentVerifyResultEnum = typeof PaymentVerifyResultEnum[keyof typeof PaymentVerifyResultEnum];


/**
 * @type PaymentVerifyResultResponse
 * @export
 */
export type PaymentVerifyResultResponse = { Response: 'Failure' } & Failure | { Response: 'Success' } & PaymentVerifyResultSuccess;

export interface PaymentVerifyResultSuccess {
    'value': PaymentVerifyResult;
    'Response': ResponseEnum;
}


export const ResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type ResponseEnum = typeof ResponseEnum[keyof typeof ResponseEnum];


/**
 * @type ScanResult
 * @export
 */
export type ScanResult = { ScanResult: 'AsIs' } & AsIs | { ScanResult: 'NotAvailable' } & NotAvailable | { ScanResult: 'NotScanned' } & NotScanned | { ScanResult: 'WithEdits' } & WithEdits;

export const ScanResultEnum = {
    AsIs: 'AsIs',
    NotAvailable: 'NotAvailable',
    NotScanned: 'NotScanned',
    WithEdits: 'WithEdits'
} as const;

export type ScanResultEnum = typeof ScanResultEnum[keyof typeof ScanResultEnum];


export const ScannedField = {
    card_number: 'card_number',
    expiration_date: 'expiration_date'
} as const;

export type ScannedField = typeof ScannedField[keyof typeof ScannedField];


export interface Success {
    'payment': CreditCard;
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


export interface UnknownCard {
    'PaymentVerifyResult': PaymentVerifyResultEnum;
}


export const UsageType = {
    MultiUsage: 'MultiUsage',
    SingleUsage: 'SingleUsage'
} as const;

export type UsageType = typeof UsageType[keyof typeof UsageType];


export interface VerifyPaymentMethodRequest {
    'token': string;
    'usageType'?: UsageType;
}


export interface WithEdits {
    'fields': Array<ScannedField>;
    'ScanResult': ScanResultEnum;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit interactive payment auth result
         * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsCompleteInteractiveAuthPut: async (completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completeInteractiveAuthRequest' is not null or undefined
            assertParamExists('apiV0PaymentMethodsCompleteInteractiveAuthPut', 'completeInteractiveAuthRequest', completeInteractiveAuthRequest)
            const localVarPath = `/api/v0/paymentMethods/completeInteractiveAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeInteractiveAuthRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete association of a credit card associated with the user\'s account
         * @param {DeletePaymentMethodRequest} deletePaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsDeletePost: async (deletePaymentMethodRequest: DeletePaymentMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deletePaymentMethodRequest' is not null or undefined
            assertParamExists('apiV0PaymentMethodsDeletePost', 'deletePaymentMethodRequest', deletePaymentMethodRequest)
            const localVarPath = `/api/v0/paymentMethods/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deletePaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specific credit card associated with the user\'s account
         * @param {GetPaymentMethodRequest} getPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsGetPost: async (getPaymentMethodRequest: GetPaymentMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getPaymentMethodRequest' is not null or undefined
            assertParamExists('apiV0PaymentMethodsGetPost', 'getPaymentMethodRequest', getPaymentMethodRequest)
            const localVarPath = `/api/v0/paymentMethods/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all credit cards associated with the user\'s account
         * @param {ListPaymentMethodsRequest} listPaymentMethodsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsListPost: async (listPaymentMethodsRequest: ListPaymentMethodsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'listPaymentMethodsRequest' is not null or undefined
            assertParamExists('apiV0PaymentMethodsListPost', 'listPaymentMethodsRequest', listPaymentMethodsRequest)
            const localVarPath = `/api/v0/paymentMethods/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(listPaymentMethodsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Poll interactive information if the payment flow need.
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsPollInteractiveAuthPut: async (body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('apiV0PaymentMethodsPollInteractiveAuthPut', 'body', body)
            const localVarPath = `/api/v0/paymentMethods/pollInteractiveAuth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verify a credit card and add to user\'s account
         * @param {VerifyPaymentMethodRequest} verifyPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsVerifyPost: async (verifyPaymentMethodRequest: VerifyPaymentMethodRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyPaymentMethodRequest' is not null or undefined
            assertParamExists('apiV0PaymentMethodsVerifyPost', 'verifyPaymentMethodRequest', verifyPaymentMethodRequest)
            const localVarPath = `/api/v0/paymentMethods/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyPaymentMethodRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit interactive payment auth result
         * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PaymentMethodsCompleteInteractiveAuthPut(completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompleteInteractiveAuthResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PaymentMethodsCompleteInteractiveAuthPut(completeInteractiveAuthRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete association of a credit card associated with the user\'s account
         * @param {DeletePaymentMethodRequest} deletePaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PaymentMethodsDeletePost(deletePaymentMethodRequest: DeletePaymentMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PaymentMethodsDeletePost(deletePaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieve a specific credit card associated with the user\'s account
         * @param {GetPaymentMethodRequest} getPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PaymentMethodsGetPost(getPaymentMethodRequest: GetPaymentMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaybeCreditCardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PaymentMethodsGetPost(getPaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List all credit cards associated with the user\'s account
         * @param {ListPaymentMethodsRequest} listPaymentMethodsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PaymentMethodsListPost(listPaymentMethodsRequest: ListPaymentMethodsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditCardListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PaymentMethodsListPost(listPaymentMethodsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Poll interactive information if the payment flow need.
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PaymentMethodsPollInteractiveAuthPut(body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InteractiveAuthResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PaymentMethodsPollInteractiveAuthPut(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verify a credit card and add to user\'s account
         * @param {VerifyPaymentMethodRequest} verifyPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PaymentMethodsVerifyPost(verifyPaymentMethodRequest: VerifyPaymentMethodRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentVerifyResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PaymentMethodsVerifyPost(verifyPaymentMethodRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Submit interactive payment auth result
         * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsCompleteInteractiveAuthPut(completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options?: any): AxiosPromise<CompleteInteractiveAuthResponseResponse> {
            return localVarFp.apiV0PaymentMethodsCompleteInteractiveAuthPut(completeInteractiveAuthRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete association of a credit card associated with the user\'s account
         * @param {DeletePaymentMethodRequest} deletePaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsDeletePost(deletePaymentMethodRequest: DeletePaymentMethodRequest, options?: any): AxiosPromise<AnyResponse> {
            return localVarFp.apiV0PaymentMethodsDeletePost(deletePaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specific credit card associated with the user\'s account
         * @param {GetPaymentMethodRequest} getPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsGetPost(getPaymentMethodRequest: GetPaymentMethodRequest, options?: any): AxiosPromise<MaybeCreditCardResponse> {
            return localVarFp.apiV0PaymentMethodsGetPost(getPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * List all credit cards associated with the user\'s account
         * @param {ListPaymentMethodsRequest} listPaymentMethodsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsListPost(listPaymentMethodsRequest: ListPaymentMethodsRequest, options?: any): AxiosPromise<CreditCardListResponse> {
            return localVarFp.apiV0PaymentMethodsListPost(listPaymentMethodsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Poll interactive information if the payment flow need.
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsPollInteractiveAuthPut(body: string, options?: any): AxiosPromise<InteractiveAuthResponseResponse> {
            return localVarFp.apiV0PaymentMethodsPollInteractiveAuthPut(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Verify a credit card and add to user\'s account
         * @param {VerifyPaymentMethodRequest} verifyPaymentMethodRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PaymentMethodsVerifyPost(verifyPaymentMethodRequest: VerifyPaymentMethodRequest, options?: any): AxiosPromise<PaymentVerifyResultResponse> {
            return localVarFp.apiV0PaymentMethodsVerifyPost(verifyPaymentMethodRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Submit interactive payment auth result
     * @param {CompleteInteractiveAuthRequest} completeInteractiveAuthRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PaymentMethodsCompleteInteractiveAuthPut(completeInteractiveAuthRequest: CompleteInteractiveAuthRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PaymentMethodsCompleteInteractiveAuthPut(completeInteractiveAuthRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete association of a credit card associated with the user\'s account
     * @param {DeletePaymentMethodRequest} deletePaymentMethodRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PaymentMethodsDeletePost(deletePaymentMethodRequest: DeletePaymentMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PaymentMethodsDeletePost(deletePaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a specific credit card associated with the user\'s account
     * @param {GetPaymentMethodRequest} getPaymentMethodRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PaymentMethodsGetPost(getPaymentMethodRequest: GetPaymentMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PaymentMethodsGetPost(getPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all credit cards associated with the user\'s account
     * @param {ListPaymentMethodsRequest} listPaymentMethodsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PaymentMethodsListPost(listPaymentMethodsRequest: ListPaymentMethodsRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PaymentMethodsListPost(listPaymentMethodsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Poll interactive information if the payment flow need.
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PaymentMethodsPollInteractiveAuthPut(body: string, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PaymentMethodsPollInteractiveAuthPut(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verify a credit card and add to user\'s account
     * @param {VerifyPaymentMethodRequest} verifyPaymentMethodRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0PaymentMethodsVerifyPost(verifyPaymentMethodRequest: VerifyPaymentMethodRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0PaymentMethodsVerifyPost(verifyPaymentMethodRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



